//  Link media
require.context("../media/", true, /^\.\/.*\.*/);
require.context("../fonts/", true, /^\.\/.*\.*/);

//  Styles
import "../styles/styles.scss";

// JS
import $ from "jquery";

import textBalancer from "text-balancer";
import utils from "./proj/utils";
import Tracker from "./proj/tracker";
import loadChartbeat from "./proj/chartbeat";
import Waypoint from "Waypoint";
import stickyWaypoints from "./proj/waypoints/sticky";
import triggerWaypoints from "./proj/waypoints/triggers";
import handleLazySizes from "./proj/handleLazySizes";
// import createGlobe from './proj/globe/globe';
import InView from "./proj/inview";
import Slick from "./proj/slick";
import canAutoPlay from "can-autoplay";

let Site;
const isMobileDevice = utils.mobileAndTabletCheck();
const isMobile = window.innerWidth < 800 || isMobileDevice;

const playVideo = function (vid) {
  var playPromise = vid.play();

  if (playPromise !== undefined) {
    playPromise
      .then(function () {
        // Automatic playback started!
      })
      .catch(function (error) {
        vid.muted = true;
        vid.play();
        // Automatic playback failed.
        // Show a UI element to let the user manually start playback.
      });
  }
};

const playNextVideo = function (containerId, videoId) {
  FAVEPlayer.getInstanceById(containerId).play(videoId);
  console.log(videoId);
};

const updateNav = function (idx) {
  if (idx == 0) {
    console.log(`Updating to part 2`);
    document.getElementById("btn_part1").classList.remove("active");
    document.getElementById("btn_part2").classList.add("active");
    document.getElementById("btn_part3").classList.remove("active");
  } else if (idx == 1) {
    console.log(`Updating to part 3`);
    document.getElementById("btn_part1").classList.remove("active");
    document.getElementById("btn_part2").classList.remove("active");
    document.getElementById("btn_part3").classList.add("active");
  }
};

const videoArray = [
  "politics/2020/01/28/we-count-voter-series-iowa-orig-jm.cnn",
  "politics/2021/02/26/biden-strikes-in-syria-axelrod-hertling-ebof-vpx.cnn",
];

textBalancer.balanceText(".d-intro-dek");

const customConfig = {
  configs: {
    autostart: true,
    player: {
      autoplay: {
        unmuted: {
          desktop: {
            playOnDocumentInteraction: true,
          },
        },
      },
    },
  },

  callbacks: {
    onContentBegin: function (containerId, playerId, videoId) {
      var videoData = FAVEPlayer.getVideoData(containerId);
      //document.querySelectorAll('.video-title')[0].innerHTML = videoData.headline;
    },

    onContentComplete: function (containerId, playerId, videoId) {
      var idx = videoArray.indexOf(videoId),
        nextVideoId = videoArray[idx == videoArray.length - 1 ? 0 : idx + 1];
      if (idx < videoArray.length - 1) {
        playNextVideo(containerId, nextVideoId);
        updateNav(videoArray.indexOf(nextVideoId));
      }
    },

    onAutoplayBlocked: function (containerId, playerId, contentId, dataObj) {
      console.log("Autostart was blocked by browser");
    },
  },
};

const pauseVideo = function (vid) {
  vid.pause();
};

const updateVideoSrc = function (vid) {
  const src = vid.getAttribute("data-vid-src");
  const newSrc = isMobile ? src.replace(".mp4", "-mob.mp4") : src;
  vid.setAttribute("data-src", newSrc);
};

(function ($) {
  "use strict";

  Site = {
    /**
     * initialize prototype
     *
     */
    init: function (elt) {
      var self = this;

      // self.waypointsChapter();
      self.cnnTracker();
      self.cnnPlayer();
      self.lazySizes();

      self.setupAutoplay();

      // project specific
      self.inviewAnimation();
      self.relatedCarousel();
      //self.handleVideoSrc();

      self.updateHero();
      self.handleWaypoints();
      // self.handleGlobe();

      self.initChartbeat();

      // setTimeout( function() {
      // 	self.startIntro();
      // }, 100);

      $("body").addClass("loaded");

      // $(window).on('resize', self.updateHero);
    },

    /**
     * inview animation
     *
     */
    inviewAnimation: function () {
      $("[class*='ivanim-']").on("inview", function (event, isInView) {
        if (isInView) {
          if (!$(this).hasClass("is-inview")) {
            $(this).addClass("is-inview");
          }
        }
      });
    },

    updateHero: function () {
      // if( isMobileDevice ) {
      // 	document.querySelector('.hero').style.height = (window.innerHeight - 52) +'px';
      // }
      setTimeout(function () {
        $(".intro-header__title").addClass("show");
      }, 500);

      setTimeout(function () {
        $(".intro-header__dek").addClass("show");
      }, 1500);

      setTimeout(function () {
        $(".intro-header__byline").addClass("show");
      }, 2500);

      setTimeout(function () {
        $(".intro-header__timestamp").addClass("show");
      }, 2500);
    },

    /**
     * related carousel footer
     *
     */
    relatedCarousel: function () {
      var speed_val = 1000;
      var speed_autoplay_val = 4000;

      setTimeout(function () {
        $(".js-related-links").slick({
          dots: true,
          infinite: true,
          speed: speed_val,
          slide: ".js-slide",
          centerMode: true,
          variableWidth: true,
          slidesToScroll: 1,
          autoplay: false,
          responsive: [
            {
              breakpoint: 480,
              settings: {
                centerMode: false,
                arrows: false,
              },
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ],
        });

        setTimeout(function () {
          window.dispatchEvent(new Event("resize"));
        }, 2000);
      }, 2000);
    },

    startIntro: function () {
      const vidContainer = document.querySelector(
        ".hero__media-video-container"
      );
      const vid = document.querySelector("#hero-video");

      // change src
      vid.setAttribute("src", vid.getAttribute("data-src"));

      // add play listener
      const onPlay = function () {
        vidContainer.className = vidContainer.className + " fade-in";
        vid.removeEventListener("play", onPlay);

        if ($(".hero__media").hasClass("show-fallback")) {
          $(".hero__media").removeClass("show-fallback");
        }
      };
      vid.addEventListener("play", onPlay);
      $(".show-fallback").on("click", function () {
        vid.play();
      });

      const onVidReady = (vid) => (event) => {
        // attempt to show title screen if video can't auto play  - Browserstack androind native browser samsung galaxy s5 / CNN app too
        const introPlayPromise = vid.play();

        if (introPlayPromise !== undefined) {
          introPlayPromise
            .then(function () {
              // Automatic playback started!
            })
            .catch(function (error) {
              $(".hero__media").addClass("show-fallback show-fallback-error");
            });
        }
      };

      vid.addEventListener("loadedmetadata", onVidReady(vid));
    },

    handleVideoSrc: function () {
      const vids = document.querySelectorAll("video[data-vid-src]");
      const suffix = isMobile ? "-mob" : "";
      [...vids].forEach(updateVideoSrc);
    },

    handleWaypoints: function () {
      let waypoints = [];
      let waypointContext = window;

      const stickyWithWaypoints = stickyWaypoints(waypoints, waypointContext);
      const stickyMedia = $(".js-sticky");
      $.each(stickyMedia, stickyWithWaypoints);

      // set up all the triggers from paragraphs
      const displayTriggers = $(".js-wp-trigger");
      let displayTriggerWaypoints = triggerWaypoints(
        waypoints,
        waypointContext
      );
      $.each(displayTriggers, displayTriggerWaypoints);
    },

    // handleGlobe: function() {
    // 	const globe = createGlobe('#js-globe');
    // },

    setupAutoplay: function () {
      const waypointContext = window;
      const autoplayLoops = $(".js-video-play-in-view");
      let waypoints = [];
      $.each(autoplayLoops, function (idx, el) {
        const $el = $(el);
        const vidId = $el.attr("data-video-target");
        const vid = document.getElementById(vidId);

        // container enters viewport (scrolling down) or leaves viewport (scrolling back up)
        waypoints.push(
          new Waypoint({
            element: el,
            handler: function (direction) {
              if (direction === "down" && vid) {
                playVideo(vid);
              } else {
                pauseVideo(vid);
              }
            },
            context: waypointContext,
            offset: "80%",
          })
        );

        // container exits (scrolling down) or enters (scrolling back up)
        waypoints.push(
          new Waypoint({
            element: el,
            handler: function (direction) {
              if (direction === "down" && vid) {
                pauseVideo(vid);
              } else {
                playVideo(vid);
              }
            },
            context: waypointContext,
            offset: function () {
              return -this.element.clientHeight;
            },
          })
        );
      });
    },

    /**
     * CNN page view trackers
     *
     */
    cnnTracker: function () {},

    /**
     * Image lazy sizes
     *
     */
    lazySizes: function () {
      handleLazySizes(this.onImageLoaded.bind(this));
    },

    onImageLoaded: function (id) {
      if (id === "splash") {
        setTimeout(function () {
          $(".intro-header").addClass("show");
        }, 100);
      }
    },

    /**
     * Image lazy sizes
     *
     */
    initChartbeat: function () {
      // relies on global set in head
      if (window.CNN && window.CNN.omniture && window.CNN.omniture.section) {
        loadChartbeat(window.CNN.omniture.section[0], "CNN Interactives");
      }
    },

    /**
     * CNN page view trackers
     *
     */

    cnnPlayer: function () {
      if (FAVEPlayer) {
        FAVEPlayer.create($(".fave"), customConfig);
      }
    },
  };

  $(document).ready(function () {
    Site.init();

    // var videoArray = [
    //     "business/2019/09/16/samsung-lab-healthcare-automotive-orig.cnn"
    // ]

    var customConfig = {
      configs: {
        autostart: true,
        player: {
          autoplay: {
            unmuted: {
              desktop: {
                playOnDocumentInteraction: true,
              },
            },
          },
        },
      },

      callbacks: {
        onContentBegin: function (containerId, playerId, videoId) {
          var videoData = FAVEPlayer.getVideoData(containerId);
          document.querySelectorAll(".video-title")[0].innerHTML =
            videoData.headline;
        },

        onContentComplete: function (containerId, playerId, videoId) {
          var idx = videoArray.indexOf(videoId),
            nextVideoId =
              videoArray[idx == videoArray.length - 1 ? 0 : idx + 1];
          playNextVideo(containerId, nextVideoId);
        },

        onAutoplayBlocked: function (
          containerId,
          playerId,
          contentId,
          dataObj
        ) {
          console.log("Autostart was blocked by browser");
        },
      },
    };

    // var videos = [].slice.call(document.querySelectorAll('[data-video-id]')).forEach(function(val, id) {
    //     val.dataset["videoId"] = videoArray[id];
    //     FAVEPlayer.create(val, customConfig);
    // });

    // playNextVideo = function(containerId, videoId) {
    //     FAVEPlayer.getInstanceById(containerId).play(videoId);
    //     console.log(videoId);
    // }
  });
})(jQuery);



// WEBPACK FOOTER //
// ./src/js/main.js